(() => {
  const bindCatalog = (scope = document) => {
    scope.querySelectorAll('[data-ovd-quick-open]').forEach((button) => {
      if (button.dataset.ovdQuickBound === 'true') return;
      button.dataset.ovdQuickBound = 'true';

      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.ovdQuickOpen || '');
        if (!(dialog instanceof HTMLDialogElement)) return;
        dialog.showModal();
      });
    });

    scope.querySelectorAll('[data-ovd-quick-dialog]').forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.ovdQuickBound === 'true') return;
      dialog.dataset.ovdQuickBound = 'true';

      dialog.querySelector('[data-ovd-quick-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      const variantId = dialog.querySelector('[data-ovd-quick-variant-id]');
      const submitButton = dialog.querySelector('.ovr-quick-buy__submit');

      dialog.querySelectorAll('[data-ovd-quick-variant]').forEach((option) => {
        option.addEventListener('change', () => {
          if (!(option instanceof HTMLInputElement) || !option.checked) return;
          if (variantId instanceof HTMLInputElement) variantId.value = option.value;
          if (submitButton instanceof HTMLButtonElement) submitButton.disabled = false;
        });
      });

      dialog.querySelector('.ovr-quick-buy__form')?.addEventListener('submit', () => {
        window.setTimeout(() => {
          if (dialog.open) dialog.close();
        }, 350);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindCatalog());
  } else {
    bindCatalog();
  }

  document.addEventListener('shopify:section:load', (event) => bindCatalog(event.target));
})();
